<div *ngIf="cardRequestDetailService.request">
    <div class="detail-header">
        <div>
            <div class="flex">
                <button pButton (click)="navigateToRequests()" [rounded]="true" [text]="true" class="P8" styleClass="p-button-rounded p-button-danger p-button-text">
                    <span class="material-symbols-outlined"> arrow_back </span>
                </button>
                <span class="bold600 font14" pTooltip="{{ 'REQUEST_DETAIL.QUERY_ID' | translate }}" tooltipPosition="top">
                    {{ cardRequestDetailService.request.personQuery.queryId }}
                </span>
                <span class="bold400 font13" pTooltip="{{ 'REQUEST_DETAIL.BIRTH_DATE' | translate }}"tooltipPosition="top">
                    @if (isValidBirthDate()) {
                        {{ cardRequestDetailService.request.personQuery.birthDate | date:'dd/MM/yyyy' }}
                    } @else {
                        {{ cardRequestDetailService.request.personQuery.birthDate }}
                    }
                </span>

                <!-- <span class="mini-separator"></span>
                <span class="bold600 font14" pTooltip="{{ 'REQUEST_DETAIL.LABORAL_REGIME' | translate }}"
                    tooltipPosition="top">{{this.cardRequestService.getPersonTypeTitle(this.cardRequestDetailService.request.personQuery.personType)
                    | translate}}</span> -->
            </div>
            <div class="flex PL50">
                <p pTooltip="{{ 'REQUEST_DETAIL.QUERY_TYPE' | translate }}" tooltipPosition="top">
                    <span class="material-symbols-outlined"> contract </span>
                    {{ cardRequestService.getQueryTypeTitle(cardRequestDetailService.request.personQuery.queryType) | translate }}
                </p>
                <p pTooltip="{{ 'REQUEST_DETAIL.PHONE' | translate }}" tooltipPosition="top">
                    <span class="material-symbols-outlined"> phone </span>
                    {{ cardRequestDetailService.request.personQuery.phoneNumber }}
                </p>
                <p pTooltip="{{ 'REQUEST_DETAIL.ID_NUMBER' | translate }}" tooltipPosition="top">
                    <span class="material-symbols-outlined"> id_card </span>
                    <span >{{ cardRequestDetailService.request.personQuery.personId }}</span>
                </p>
                <p pTooltip="{{ 'MY_REQUESTS.USER' | translate }}" tooltipPosition="top">
                    <span class="material-symbols-outlined"> person </span>
                    <span >{{ temporarilyModifyReqRef(cardRequestDetailService.request.personQuery.requestReference) }}</span>
                </p>
            </div>
        </div>
        <div class="flex">
            <div class="flex-column" *ngIf="cardRequestDetailService.request.personQuery.personIdExpirationDate">
                <p class="font11 MB0 center">{{ 'REQUEST_DETAIL.ID_EXPIRATION_DATE' | translate }}</p>
                <p class="date-box">{{ cardRequestDetailService.request.personQuery.personIdExpirationDate | date: 'dd/MM/yyyy' }}</p>
            </div>
            <div class="flex-column">
                <p class="font11 MB0 center">{{ 'REQUEST_DETAIL.REQUEST_DATE' | translate }}</p>
                <p class="date-box">{{ cardRequestDetailService.request.personQuery.createdDateTime | date: 'dd/MM/yyyy HH:mm' }}</p>
            </div>
            <div class="flex-column" *ngIf="cardRequestDetailService.request.personQuery.isDocumentsDowloadCompleted">
                <p class="font11 MB0 center">{{ 'REQUEST_DETAIL.DOWNLOAD_DOCUMENTS' | translate }}</p>
                <p class="date-box document-check">
                    <span class="material-symbols-outlined"> done_all </span>
                </p>
            </div>
            <div class="flex-column" *ngIf="cardRequestDetailService.isDecisionAvailable()">
                @if(cardRequestDetailService.isDecision('Viable')) {
                    <p class=" font11 MB0 center">{{ 'REQUEST_DETAIL.FEASIBLE' | translate }}</p>
                    <p class="date-box document-check">
                        <span class="material-symbols-outlined"> check </span>
                    </p>
                } @else if (cardRequestDetailService.isDecision('No viable')) {
                    <p class="font11 MB0 center">{{ 'REQUEST_DETAIL.NOT_FEASIBLE' | translate }}</p>
                    <p class="date-box document-denied">
                        <span class="material-symbols-outlined"> close </span>
                    </p>
                }
            </div>
        </div>
        <div class="flex-column align-center">
            <p tooltipPosition="left" [pTooltip]="'REQUEST_DETAIL.STATUS' | translate" [class]="'actual-status ' + cardRequestDetailService.request.personQuery.status">
                {{ translatedStatus }}
            </p>
            <p class="actual-sub-status" tooltipPosition="left" [pTooltip]="'REQUEST_DETAIL.SUBSTATUS' | translate">
                {{ translatedSubStatus }}
            </p>
        </div>
    </div>
</div>
